import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class CommissionService {
  constructor(private api: ApiService) {}

  // GET API
  getListingCommissionsByAgentId(agentId: string) {
    return this.api.get(`/get-agent-listings-commission?user_id=${agentId}&office_id=${this.api.getOfficeId()}`);
  }
  getCommissionListByAgentId(agentId: string) {
    return this.api.get(`/get-agent-commissions/${agentId}`);
  }
  getCommissionListByOfficeId() {
    return this.api.get(`/get-office-commissions/${this.api.getOfficeId()}`);
  }

  // PUT API

  updateOfficeCommission(payload: any) {
    return this.api.put('/office-commissions/' + this.api.getOfficeId(), payload);
  }
  updateAgentCommission(staff_id, payload: any) {
    return this.api.put('/agent-commissions/' + staff_id, payload);
  }
}
